// eslint-disable-next-line import/prefer-default-export
export const MFA_SELECT_CHANNEL_PAGE_NAME = 'mfa:one-time-code';
export const MFA_ENTER_CODE = 'mfa:one-time-code-sent';
export const CONFIRM_YOUR_MOBILE_NUMBER = 'confirm-your-mobile-number';

export const EVENT_OTC_ERROR = 'otc-error';
